import React, { useContext, useEffect, useState } from "react";
//
import { useNavigate } from "react-router";
import { useIntl, FormattedMessage } from "react-intl";
// ui
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import CircularProgress from "@mui/material/CircularProgress";
import { styled } from "@material-ui/styles";
import ButtonMain from "../../../../../../../common/components/button/ButtonMain";
//
import ButtonPopup from "../../../../../../../common/components/popup/ButtonPopup";
// store
import { StoreContext } from "../../../../../../../store/StoreProvider";
import Act from "../../../../../../../store/actions";
//
import importIcon from "../../../../../../../../images/icon_import/icon_import_dark/匯入.svg";
// hooks
import useModulePublic from "../../../../../../hooks/useModulePublic";
// config,utils
import { MODULE_ID } from "../../../../../../../config/CONSTANTS";
import {
  readFile,
  uploadFile,
  readAndUploadFileApi,
  readAndUploadFileLocal,
} from "./utils/importHelper";
import fireDb from "../../../../../../../api/firebase/realtime/utils";
import ApiUrls from "../../../../../../../api/project/ApiUrls";
import { isElectronApp } from "../../../../../../../common/utils/electronAppHelper";

const popupMenuPosition = {
  anchorOrigin: {
    vertical: "bottom",
    horizontal: "right",
  },
  transformOrigin: {
    vertical: "top",
    horizontal: "right",
  },
};

const ImportTool = () => {
  // props

  // route,intl
  const intl = useIntl();
  // store
  const [state, dispatch] = useContext(StoreContext);
  const { sna, user } = state;
  const { dataset } = sna;
  const { token } = user;
  // local state
  const [popupPageIdx, setPopupPageIdx] = useState(0);
  const [popPageCtx, setPopPageCtx] = useState({});
  const [uploadLoading, setUploadLoading] = useState(false);
  // hooks
  const { handlePublic } = useModulePublic();

  const handleDisabled = (moduleId) => !handlePublic(moduleId);

  const handleUpload = (e) => {
    // todo: 處理上傳的檔案, lxt-api or local
    // 檢查資料格式, 轉換資料格式, 建立檔名, 儲存到預定位置,
    // 更新 firebase/files/uid 及 users/uid/files

    const onUpdateRtSuccess = () => {
      dispatch({
        type: Act.SNA_DIALOG_CONTEXT,
        payload: {
          openSignal: true,
          title: intl.formatMessage({
            id: "sna.topPanel.import.upload.file.success.title",
            defaultMessage: "已上傳檔案至資料集",
          }),
          contentText: intl.formatMessage({
            id: "sna.topPanel.import.upload.file.success.content",
            defaultMessage: "檔案已上傳完成，請前往資料集查看。",
          }),
          yesText: intl.formatMessage({
            id: "sna.topPanel.import.upload.file.success.content.confirm",
            defaultMessage: "好",
          }),
          withFinishIcon: true,
        },
      });
      // 更新 dataset.personal
      dispatch({
        type: Act.SNA_REFRESH_PERSONAL_DATASET,
        payload: true,
      });
      //
      setUploadLoading(false);
    };

    const onUpdateRtError = (err) => {
      dispatch({
        type: Act.COMMON_SET_ERROR_MESSAGE,
        payload: {
          open: true,
          content: err?.message,
        },
      });
      setUploadLoading(false);
    };

    if (isElectronApp()) {
      readAndUploadFileLocal({
        user,
      });
    } else {
      readAndUploadFileApi({
        user,
        token,
        onUploadStart: () => {
          setUploadLoading(true);
        },
        onSuccess: onUpdateRtSuccess,
        onError: onUpdateRtError,
        state,
      });
    }
  };

  const handleDownload = () => {
    const downloadUrl = ApiUrls.getDownloadTemplate().replace(
      "{pattern}",
      "sna"
    );
    window.open(downloadUrl, "_blank", "noopener,noreferrer");
  };

  const getPopupPage0 = () => ({
    body: [
      {
        children: (
          <Box px={3} py={2}>
            <Box mb={4}>
              <Typography variant="body2">
                <FormattedMessage
                  id="sna.topPanel.import.popup.title"
                  defaultMessage="匯入"
                />
              </Typography>
            </Box>
            <Box mb={2}>
              <ButtonMain
                buttonProps={{
                  text: intl.formatMessage({
                    id: "sna.topPanel.import.popup.upload.file",
                    defaultMessage: "上傳檔案",
                  }),
                  fullWidth: true,
                  variant: "gradient",
                  onClick: handleUpload,
                  startIcon: uploadLoading ? (
                    <CircularProgress size="16px" color="text" />
                  ) : null,
                }}
              />
            </Box>
            <Box mb={2}>
              <ButtonMain
                buttonProps={{
                  text: intl.formatMessage({
                    id: "sna.topPanel.import.popup.download.template",
                    defaultMessage: "下載範本",
                  }),
                  fullWidth: true,
                  variant: "outlined",
                  onClick: handleDownload,
                }}
              />
            </Box>
            <Box mb={2}>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.title"
                  defaultMessage="上傳檔案說明："
                />
              </Typography>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.content0"
                  // defaultMessage="1. 請上傳xlsx, tsv, ucinet, gephi檔"
                  defaultMessage="1. 請上傳xlsx檔"
                />
              </Typography>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.content1"
                  defaultMessage="2. 檔案容量最大 20MB，資料筆數小於1000筆"
                />
              </Typography>
            </Box>
            <Box>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.title2"
                  defaultMessage="檔案欄位說明："
                />
              </Typography>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.content2"
                  defaultMessage="(1)起點"
                />
              </Typography>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.content3"
                  defaultMessage="(2)終點"
                />
              </Typography>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.content4"
                  defaultMessage="(3)原始資料"
                />
              </Typography>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.content5"
                  defaultMessage="(4)關係"
                />
              </Typography>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.content6"
                  defaultMessage="(5)主事件分類"
                />
              </Typography>
              <Typography variant="caption" display="block">
                <FormattedMessage
                  id="sna.topPanel.import.popup.information.content7"
                  defaultMessage="(6)子事件分類"
                />
              </Typography>
            </Box>
          </Box>
        ),
        useMenuItem: false,
      },
    ],
  });

  // popup 所有分頁
  const popupPages = [getPopupPage0()];

  // 當選擇的 dataset 變更 or pageIdx 便更時, 重新產生 popup 內容
  useEffect(() => {
    setPopPageCtx(popupPages[popupPageIdx]);
  }, [popupPageIdx, user, uploadLoading]);

  const getMenuProps = () => ({
    ...popPageCtx,
    ...popupMenuPosition,
    onClose: () => setPopupPageIdx(0),
    sx: {
      "& .MuiPopover-paper": {
        minWidth: "248px",
      },
    },
  });

  return (
    <Box>
      <ButtonPopup
        buttonProps={{
          variant: "neutral",
          text: intl.formatMessage({
            id: "sna.topPanel.import",
            defaultMessage: "匯入",
          }),
          disabled: handleDisabled(MODULE_ID.snaTopPanelImport),
          startIcon: <img src={importIcon} alt="importIcon" />,
        }}
        menuProps={{
          ...getMenuProps(),
        }}
      />
    </Box>
  );
};

ImportTool.propTypes = {};

ImportTool.defaultProps = {};

export default ImportTool;
